export const firebaseConfig = {
    apiKey: 'AIzaSyAEQWx8tFCqInewk7Sflq75b8t4n3LMjfo',
    authDomain: 'pole-journal-581b9.firebaseapp.com',
    projectId: 'pole-journal-581b9',
    storageBucket: 'pole-journal-581b9.appspot.com',
    messagingSenderId: '519819873387',
    appId: '1:519819873387:web:5dbe0af0557030c345b52e',
    measurementId: 'G-9YD8KRE4TT'
};
